import React, { Component } from "react";
import { connect } from "react-redux";
import {
  retrieveMateriels,
  findMaterielsByTitle,
  deleteAllMateriels,
} from "../actions/materiel";
import { Link } from "react-router-dom";

class MaterielsList extends Component {
  constructor(props) {
    super(props);
    this.onChangeSearchNom = this.onChangeSearchNom.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.setActiveMateriel = this.setActiveMateriel.bind(this);
    this.findByNom = this.findByNom.bind(this);
    this.removeAllMateriels = this.removeAllMateriels.bind(this);

    this.state = {
      currentMateriel: null,
      currentIndex: -1,
      searchNom: "",
    };
  }

  componentDidMount() {
    this.props.retrieveMateriels();

  }

  onChangeSearchNom(e) {
    const searchNom = e.target.value;

    this.setState({
      searchNom: searchNom,
    });
  }

  refreshData() {
    this.setState({
      currentMateriel: null,
      currentIndex: -1,
    });
  }

  setActiveMateriel(materiel, index) {
    this.setState({
      currentMateriel: materiel,
      currentIndex: index,
    });
  }

  removeAllMateriels() {
    this.props
      .deleteAllMateriels()
      .then((response) => {
        console.log(response);
        this.refreshData();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  findByNom() {
    this.refreshData();

    this.props.findMaterielsByTitle(this.state.searchNom);
  }

  render() {
    const { searchNom, currentMateriel, currentIndex } = this.state;
    const { materiels } = this.props;


    return (
      <div className="list row">
        <div className="col-md-8">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher du matériel"
              value={searchNom}
              onChange={this.onChangeSearchNom}
            />

            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.findByNom}
              >
                Rechercher
              </button>

            </div>

          </div>
        </div>
        <div className="col-md-6">
          <h4>Liste du materiel</h4>

          <ul className="list-group">

            {materiels &&
            materiels.map((materiel, index) => (

                  <li
                  className={
                    "list-group-item " +
                    (index === currentIndex ? "active" : "")
                  }

                  onClick={() => this.setActiveMateriel(materiel)}
                  key={materiel.id}

                >
                    <ul> {materiel.Nom}
                    </ul>
                    <ul>{materiel.Provenance}</ul>
                </li>


              ))}
          </ul>

          <button
            className="m-3 btn btn-sm btn-danger"
            onClick={this.removeAllMateriels}
          >
            Supprimer tout le matériel
          </button>
        </div>
        <div className="col-md-6">
          {currentMateriel ? (
            <div>
              <h4>Matériel</h4>
              <div>
                <label>
                  <strong>Nom:</strong>
                </label>{" "}
                {currentMateriel.Nom}
              </div>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>{" "}
                {currentMateriel.published ? "Published" : "Pending"}
              </div>

              <Link
                to={"/materiels/" + currentMateriel.id}
                className="badge badge-warning"
              >
                Editer
              </Link>
            </div>
          ) : (
            <div>
              <br />
              <p>Cliquez sur un matériel ou  </p>
              <p>  <a className="nav-item"
                            href="https://pointage.ansart-tp.com/addmateriels" type="button"> Ajouter du matériel</a>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    materiels: state.materiels,
  };
};

export default connect(mapStateToProps, {
  retrieveMateriels,
  findMaterielsByTitle,
  deleteAllMateriels,
})(MaterielsList);
